import { useState } from 'react';
import { ResendMessageOptions } from '../types';
import { EventHistoryModalsContext } from './EventHistoryModalsContext';

export const EventHistoryModalsContextProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [resendMessageModalOptions, setResendMessageModalOptions] =
    useState<ResendMessageOptions | null>(null);
  const isResendMessageModalVisible = !!resendMessageModalOptions;
  const showResendMessageModal = (options: ResendMessageOptions) =>
    setResendMessageModalOptions(options);
  const closeModal = () => {
    setResendMessageModalOptions(null);
  };

  return (
    <EventHistoryModalsContext.Provider
      value={{
        resendMessageModalOptions,
        isResendMessageModalVisible,
        showResendMessageModal,
        closeModal,
      }}
    >
      {children}
    </EventHistoryModalsContext.Provider>
  );
};
